import { makeStyles } from '@material-ui/core';

export const contaModalStyles = makeStyles(() => ({
  container: {
    flexGrow: 1,
    padding: 16,
    maxWidth: 600,
  },
}));
